import React, { useState } from "react";
import {
  X,
  Save,
  Edit2,
  Trash2,
  CheckCircle2,
  ListTodo,
  CalendarClock,
} from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";
const hdrs = { "Content-Type": "application/json", Authorization: secretKey };

const TYPES = [
  { value: "zwykłe", label: "Zadanie", icon: ListTodo },
  { value: "spotkanie", label: "Spotkanie", icon: CalendarClock },
];

const AddTask = (props) => {
  const isEdit = props.mode === "edit";
  const isPending = isEdit && props.task?.status === "ZLECONE";
  const canEdit =
    isPending &&
    (+props.task?.user === +props.user.id || props.user.role === "admin");

  const [editing, setEditing] = useState(!isEdit);
  const [task, setTask] = useState(
    isEdit ? props.task.task : props.prefill?.prefillTask || ""
  );
  const [date, setDate] = useState(
    isEdit ? props.task.date : props.prefill?.prefillDate || ""
  );
  const [note, setNote] = useState(
    isEdit ? props.task.note : props.prefill?.prefillNote || ""
  );
  const [type, setType] = useState(
    isEdit ? props.task.type || "zwykłe" : "zwykłe"
  );
  const [hour, setHour] = useState(isEdit ? props.task.hour || "" : "");
  const [isSalesCall, setIsSalesCall] = useState(false);

  const validate = () => {
    if (!task.trim() || !date) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "wymagane pola formularza",
      });
      return false;
    }
    if (type === "spotkanie" && !hour) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "podaj godzinę spotkania",
      });
      return false;
    }
    return true;
  };

  const handleDateChange = (e) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (new Date(e.target.value) < today) {
      MySwal.fire({
        icon: "error",
        title: "Data zadania",
        text: "musi nastąpić w przyszłości",
      });
      return;
    }
    setDate(e.target.value);
  };

  const buildTaskName = () =>
    type === "spotkanie" && isSalesCall
      ? `rozmowa sprzedażowa - ${task}`
      : task;

  const postAndClose = async (endpoint, body, title, text) => {
    try {
      await fetch(`${API}/${endpoint}`, {
        method: "POST",
        headers: hdrs,
        body: JSON.stringify(body),
      });
      MySwal.fire({ icon: "success", title, text });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSave = () => {
    if (!validate()) return;
    const payload = {
      task: buildTaskName(),
      date,
      note,
      type,
      hour: type === "spotkanie" ? hour : "",
    };
    if (isEdit) {
      postAndClose(
        "editTask",
        {
          ...payload,
          id: props.task.id,
          userId: props.user.id,
          userName: props.user.name,
        },
        type === "spotkanie" ? "Spotkanie" : "Zadanie",
        "zmienione"
      );
    } else {
      postAndClose(
        "addTask",
        {
          ...payload,
          user: props.user.id,
          id: props.lead.id,
          add: "manual",
          userId: props.user.id,
          userName: props.user.name,
        },
        type === "spotkanie" ? "Spotkanie" : "Zadanie",
        "dodane"
      );
    }
  };

  const handleAccept = () =>
    postAndClose(
      "acceptTask",
      { id: props.task.id, userId: props.user.id, userName: props.user.name },
      "Zadanie",
      "wykonane"
    );

  const handleDelete = () =>
    postAndClose(
      "deleteTask",
      { id: props.task.id, userId: props.user.id, userName: props.user.name },
      "Zadanie",
      "usunięte"
    );

  const cancelEdit = () => {
    setEditing(false);
    setTask(props.task.task);
    setDate(props.task.date);
    setNote(props.task.note);
    setType(props.task.type || "zwykłe");
    setHour(props.task.hour || "");
    setIsSalesCall(false);
  };

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 560 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {type === "spotkanie" ? (
              <CalendarClock size={18} />
            ) : (
              <ListTodo size={18} />
            )}
            <div>
              <h2 className="sn-title">
                {editing
                  ? isEdit
                    ? "Edytuj zadanie"
                    : "Dodaj zadanie"
                  : "Zadanie"}
              </h2>
              <span className="sn-subtitle">Użytkownik: {props.user.name}</span>
            </div>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="sn-body">
          {isEdit && (
            <div style={{ marginBottom: 16 }}>
              <span
                className={`ld-status ${
                  props.task.status === "WYKONANE"
                    ? "ld-status--done"
                    : "ld-status--pending"
                }`}
              >
                {props.task.status}
              </span>
            </div>
          )}

          <div className="scc-form-grid">
            {/* Typ */}
            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">Typ</label>
              <div className="tc-type-toggle">
                {TYPES.map((t) => {
                  const Icon = t.icon;
                  return (
                    <button
                      key={t.value}
                      type="button"
                      className={`tc-type-btn ${
                        type === t.value ? "tc-type-btn--active" : ""
                      }`}
                      disabled={!editing}
                      onClick={() => {
                        setType(t.value);
                        if (t.value !== "spotkanie") setIsSalesCall(false);
                      }}
                    >
                      <Icon size={14} /> {t.label}
                    </button>
                  );
                })}
              </div>
            </div>

            {/* Checkbox rozmowa sprzedażowa — tylko dla spotkania */}
            {type === "spotkanie" && editing && (
              <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
                <label className="al-checkbox-label">
                  <input
                    type="checkbox"
                    className="db-check"
                    style={{ margin: 0 }}
                    checked={isSalesCall}
                    onChange={(e) => setIsSalesCall(e.target.checked)}
                  />
                  Rozmowa sprzedażowa
                </label>
              </div>
            )}

            <div className="rp-field">
              <label className="db-field-label">
                {type === "spotkanie" ? "Temat spotkania" : "Zadanie"}{" "}
                <span className="scc-req">*</span>
              </label>
              <input
                type="text"
                className="db-input"
                disabled={!editing}
                value={task}
                onChange={(e) => setTask(e.target.value)}
              />
            </div>

            <div className="rp-field">
              <label className="db-field-label">
                Data <span className="scc-req">*</span>
              </label>
              <input
                type="date"
                className="db-input"
                disabled={!editing}
                value={date}
                onChange={handleDateChange}
              />
            </div>

            {/* Godzina — tylko spotkanie */}
            {type === "spotkanie" && (
              <div className="rp-field">
                <label className="db-field-label">
                  Godzina <span className="scc-req">*</span>
                </label>
                <input
                  type="time"
                  className="db-input"
                  disabled={!editing}
                  value={hour}
                  onChange={(e) => setHour(e.target.value)}
                />
              </div>
            )}

            <div className="rp-field" style={{ gridColumn: "1 / -1" }}>
              <label className="db-field-label">Notatka</label>
              <textarea
                className="db-input ac-textarea"
                disabled={!editing}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder="Opcjonalna notatka..."
              />
            </div>
          </div>

          <div className="scc-form-footer">
            {editing && (
              <button className="lq-btn lq-btn--success" onClick={handleSave}>
                <Save size={14} /> {isEdit ? "Zapisz" : "Dodaj"}
              </button>
            )}

            {canEdit && !editing && (
              <>
                <button
                  className="lq-btn lq-btn--primary"
                  onClick={() => setEditing(true)}
                >
                  <Edit2 size={14} /> Edytuj
                </button>
                <button
                  className="lq-btn lq-btn--success"
                  onClick={handleAccept}
                >
                  <CheckCircle2 size={14} /> Oznacz jako wykonane
                </button>
              </>
            )}

            {canEdit && editing && isEdit && (
              <button className="lq-btn lq-btn--muted" onClick={cancelEdit}>
                Anuluj edycję
              </button>
            )}

            {canEdit && (
              <button className="lq-btn lq-btn--danger" onClick={handleDelete}>
                <Trash2 size={14} /> Usuń
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTask;
